import { cn } from '../../lib/utils'
import { useAlertPhase } from '../../hooks/useAlertPhase'
import { useUrgencyStore } from '../../stores/urgency'
import { InstrumentPanel } from '../../components/instrument/InstrumentPanel'
import { StatusStrip } from './components/StatusStrip'
import { AlertVignette } from './components/AlertVignette'
import { StatsGrid } from './components/StatsGrid'
import { RecentQuakeList } from './components/RecentQuakeList'
import { CommandMap } from './components/CommandMap'
import { EventDrawer } from './components/EventDrawer'
import { TriggerTimelineChart } from './components/TriggerTimelineChart'
import { LiveStationsPanel } from './components/LiveStationsPanel'

/** 态势总览：状态条 + L7 地图主视 + 右侧统计/事件流/图表；警报相位驱动全局紧迫视觉 */
export function CommandPage() {
  const phase = useAlertPhase()
  const urgent = useUrgencyStore((s) => s.urgent)
  const shaking = urgent || phase === 'CRITICAL'

  return (
    <div data-phase={phase} className={cn('relative', shaking && 'shake-critical')}>
      <AlertVignette phase={phase} urgent={urgent} />
      <StatusStrip phase={phase} />
      <div className="mt-3 grid gap-4 xl:grid-cols-[minmax(0,1fr)_360px]">
        <div className="min-h-[560px]">
          <CommandMap />
        </div>
        <div className="flex min-h-[560px] flex-col gap-4">
          <StatsGrid />
          <RecentQuakeList />
        </div>
      </div>
      <div className="mt-4 grid gap-4 xl:grid-cols-3">
        <TriggerTimelineChart />
        <LiveStationsPanel />
        <InstrumentPanel title="链路状态" meta="SYS-LINK/01">
          <dl className="grid grid-cols-2 gap-x-6 gap-y-2.5 text-xs">
            <div className="flex justify-between"><dt className="text-muted-foreground">感知层</dt><dd className="font-mono text-foreground">UDP :9000</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">调度层</dt><dd className="font-mono text-foreground">天穹·枢 :8080</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">消息总线</dt><dd className="font-mono text-foreground">EMQX ws :8083</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">预警通道</dt><dd className="font-mono text-foreground">MQTT QoS 1</dd></div>
          </dl>
          <p className="mt-3 border-t border-border pt-3 text-[11px] leading-5 text-muted-foreground">
            手机端触发 → ST-DBSCAN 聚类 → 四层验证 → 震中反演 → 分级推送。本页数据全部来自真实后端，
            空态表示链路暂无事件。
          </p>
        </InstrumentPanel>
      </div>
      <EventDrawer />
    </div>
  )
}
